// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__19OHt","loaderOuter":"PageOverlayLoader_loaderOuter__8bOOF"};